import { useQuery } from '@tanstack/react-query';
import { EventTypeEnum, GetEventQuery, Event } from '../API';
import { getAllUpcomingEvents, getEventById } from '../services/events';

const useGetUpcomingEvents = (eventType: EventTypeEnum = EventTypeEnum.SMALL_GROUP, limit: number = 1, eid: string | null = null) => {
  let options = null;
  if (eid !== null && eid !== '') options = { enabled: !!eid };
  const { isLoading, data } = useQuery(
    ['events', eventType],
    eid !== null && eid !== '' ? async () => await getEventById(eid as string) : async () => await getAllUpcomingEvents(eventType, limit),
    { ...options }
  );

  return {
    isLoading,
    data: data as GetEventQuery['getEvent'][] | Event,
  };
};

export default useGetUpcomingEvents;
